import {ClientDelinkQuery, ClientDelinkMsg, FuidBidInfoJson} from '../autogenerated/ZoomBridge';
import {getLocalPathFuidJsonArray} from "../util/SelectedItemUtil";
import {forceUpdateStatus} from "../util/AssetsUtil";
import t from '../i18n/I18n';
import _ from 'lodash';


export default class GetdelinkQuery {
  updateProgress = _.noop;

  constructor(items, updateProgress) {
    this.items = items;
    this.updateProgress = updateProgress;
  }

  run() {
    let jsonArray: Array<FuidBidInfoJson> = getLocalPathFuidJsonArray(this.items);
    return new Promise((onSuccess, onFailure) => {
      if (jsonArray.length === 0) {
        onSuccess(true);
      } else {
        const query = new ClientDelinkQuery();
        let clientDelinkMsg: ClientDelinkMsg = new ClientDelinkMsg();
        clientDelinkMsg.setInfilesJsonArray(jsonArray);
        query.message = clientDelinkMsg;
        this.updateProgress(0, t('PLEASE_WAIT'), 'RUNNING');
        query.run()
          .then(
            (resp) => {
              this.updateProgress(100, resp.getSuccessMessage(), 'DONE');
              forceUpdateStatus(this.items, false);
              onSuccess(resp);
            },
            (failedResp) => {
              onFailure(failedResp);
            }
          )
          .finally(() => {
            if (this.updateProgress) {
              this.updateProgress(100, "", null)
            }
          })
      }
    });
  };

}